import { render, staticRenderFns } from "./CheckPolygon.vue?vue&type=template&id=edd70c32"
import script from "./CheckPolygon.vue?vue&type=script&lang=js"
export * from "./CheckPolygon.vue?vue&type=script&lang=js"
import style0 from "./CheckPolygon.vue?vue&type=style&index=0&id=edd70c32&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports